// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MGpA","newExpiryDate":"styles_newExpiryDate__33TGx","footer":"styles_footer__3TMoy"};